<script>
  import { watchResize } from "svelte-watch-resize";

  export let label;

  let bgWidth;

  function handleResize( node ) {
    // console.log( JSON.stringify(node) );
    // console.log( 'new width', node.clientWidth);
    bgWidth =  node.clientWidth + 'px';
  }
</script>

<div 
  use:watchResize={handleResize}
  style="--bg-width: {bgWidth};"
  >
  <span class="background"/>
  {#if label}
    <h2>{label}</h2>
  {/if}
</div>

<style>
  div {
    position: relative;
    z-index: 1;
    display: inline-block;
  }

  .background {
    display: block;
    position: absolute;
    z-index: -1;
    height: 100%;
    width: var(--bg-width);
    /*
      The diagonal border on the right was styled using a skewed ::after element.
      However, this ::after would be visible even if span.width is ZERO while label is not loaded yet.
      To prevent this FOUC, let's use a tilted linear gradient:
     */
    /* background-color: var(--color-accent-yellow); */
    /* background: linear-gradient(102deg, var(--color-accent-yellow) 80%, transparent 80.1%); */
    background: linear-gradient(102deg, var(--color-accent-yellow) calc(100% - 0.7em), transparent calc(100.1% - 0.7em));
    padding-right: 1em;
    
    transition: width 0.3s cubic-bezier(0.22, 0.61, 0.36, 1)
  }

  h2 {
    color: var(--color-blue-dark);
    /* color: black; */
    
    padding: 0.3em 0.6em;
    margin: 0;
  }
</style>
